import React from "react";

export const SplitScene = ({ id, aside, asideClassName = "", children, testId }) => (
  <section id={id} className="bp-scene bp-split" data-testid={testId}>
    <div className="bp-wrap bp-split-grid">
      <div className="bp-split-body">{children}</div>
      <div className={`bp-split-aside ${asideClassName}`}>{aside}</div>
    </div>
  </section>
);
